import React, { useContext, useState, useCallback, useEffect } from "react";
import AuthContext from "../../context/AuthContext";
import Paginator from "../paginator/Paginator";
import { Link } from "react-router-dom";
import {
  getVisitasService,
  deleteVisitaService,
} from "../../utils/VisitasService";
import DeleteVisitaButton from "./DeleteVisitaButton";
import VerVisitaModal from "./VerVisitaModal";
import Loading from "../loading/Loading";

import VerDeudoresModal from "./VerDeudoresModal";
import VerCajaModal from "./VerCajaModal";


function TablaVisitas() {
  const { authTokens } = useContext(AuthContext);
  const [visitas, setVisitas] = useState([]);
  const [displayVisitas, setDisplayVisitas] = useState([]);

  // States de la barra de busqueda.
  const [busqueda, setBusqueda] = useState("");
  const [date, setDate] = useState("");
  const [busquedaResult, setBusquedaResult] = useState([]);

  // State Loading
  const [loading, setLoading] = useState(true);

  // Funciones encargadas de pedir info a la db.
  const getVisitas = useCallback(async () => {
    const visitas = await getVisitasService(authTokens);
    setVisitas(visitas ?? []);
    setLoading(false);
  }, [authTokens]);

  const deleteVisita = useCallback(
    async (id) => {
      await deleteVisitaService(id, authTokens);
      const aux = visitas.filter((visita) => visita.id !== id);
      setVisitas(aux);
      setBusqueda("");
    },
    [authTokens, visitas]
  );

  useEffect(() => {
    getVisitas();
  }, [getVisitas, VerDeudoresModal]);


  // Cada vez que 'date' o 'busqueda' cambien, corremos search()
  useEffect(() => {
    search();
  }, [date, busqueda]);

  // Cuando presionamos el boton borrar inicializamos nuevamente ambas variables del buscador
  const handleBorrar = () => {
    setBusqueda("");
    setDate("");
  };

  // onChange handlers
  const handleDateChange = (dateSearch) => {
    setDate(dateSearch);
  };
  const handleSearchChange = (search) => {
    setBusqueda(search);
  };

  // Funcion que maneja la busqueda
  const search = () => {
    // Si se escribio algo en busqueda filtramos sobre todas las visitas
    let aux = visitas.filter((visita) =>
      getFullName(visita).includes(busqueda.toLocaleLowerCase())
    );

    // Si tambien se esta buscando por fecha aplicamos un segundo filtro
    aux =
      date !== "" ? aux.filter((visita) => visita.fecha.includes(date)) : aux;
    setBusquedaResult(aux);
  };

  const getFullName = (visita) => {
    return (
      visita.nombre.toLowerCase() +
      " " +
      visita.apellido.toLowerCase() +
      " " +
      visita.apellido.toLowerCase() +
      " " +
      visita.nombre.toLowerCase()
    );
  };

  return (
    <div>
      <div className="row">
        <div className="mt-4  d-flex justify-content-start">
          <h4>Visitas</h4>
        </div>
      </div>
      <div className="row">

        <div className="col-lg-3 py-4 col-sm-12 d-flex justify-content-between">
          <Link className="btn btn-success btn-sm" to="/nuevavisita">
            Nueva visita
          </Link>
          <VerCajaModal visitas={visitas} />
          <VerDeudoresModal visitas={visitas} setVisitas={setVisitas} />
        </div>
        <div className="col-lg-9 col-sm-12">
          <div className="input-group input-group-sm my-4">
            <input
              type="text"
              className="form-control"
              placeholder="Buscar por Nombre y Apellido."
              value={busqueda}
              onChange={(e) => handleSearchChange(e.target.value)}
            />
            <input
              placeholder="Fecha"
              type="date"
              className="form-control"
              value={date}
              onChange={(e) => handleDateChange(e.target.value)}
            />

            <div className="input-group-append">
              <button
                className="btn btn-outline-dark btn-sm"
                onClick={handleBorrar}
                type="button"
              >
                {busqueda || date ? "Borrar" : "Buscar"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="table-responsive">
            <table className="table table-sm table-hover table-dark">
              <caption>Listado de Visitas</caption>
              <thead>
                <tr>
                  <th className="col-2">Fecha</th>
                  <th className="col-2">Cliente</th>
                  <th className="col-1">Productos</th>
                  <th className="col-1">Servicios</th>
                  <th className="col-1">Total</th>
                  <th className="col-2">Forma de Pago</th>
                  <th className="col-2">Accion</th>
                </tr>
              </thead>

              <tbody>
                {busqueda.length > 0 || date.length > 0
                  ? busquedaResult.map((visita) => {
                      return (
                        <tr key={visita.id_visita} className="table-light ">
                          <td>{visita.fecha}</td>
                          <td>
                            {visita.nombre} {visita.apellido}
                          </td>
                          <td>${visita.totalProductos}</td>
                          <td>${visita.totalServicios}</td>
                          <td>${visita.total}</td>
                          <td>
                            {visita.formaDePago === "Debe" ? (
                              <span className="badge bg-danger">Debe</span>
                            ) : (
                              <span className="badge bg-info">
                                {visita.formaDePago}
                              </span>
                            )}
                          </td>
                          <td>
                            <VerVisitaModal
                              id={visita.id_visita}
                              authTokens={authTokens}
                            />
                            <DeleteVisitaButton
                              id={visita.id_visita}
                              deleteVisita={deleteVisita}
                              setVisitas={setVisitas}
                            />
                          </td>
                        </tr>
                      );
                    })
                  : displayVisitas.map((visita) => {
                      return (
                        <tr key={visita.id_visita} className="table-light ">
                          <td>{visita.fecha}</td>
                          <td>
                            {visita.nombre} {visita.apellido}
                          </td>
                          <td>${visita.totalProductos}</td>
                          <td>${visita.totalServicios}</td>
                          <td>${visita.total}</td>
                          <td>
                            {visita.formaDePago === "Debe" ? (
                              <span className="badge bg-danger">Debe</span>
                            ) : (
                              <span className="badge bg-info">
                                {visita.formaDePago}
                              </span>
                            )}
                          </td>
                          <td>
                            <VerVisitaModal
                              id={visita.id_visita}
                              authTokens={authTokens}
                            />
                            <DeleteVisitaButton
                              id={visita.id_visita}
                              deleteVisita={deleteVisita}
                              setVisitas={setVisitas}
                            />
                          </td>
                        </tr>
                      );
                    })}
              </tbody>
            </table>
          </div>
            <br />
            <div>
            <Paginator items={visitas} setDisplayItems={setDisplayVisitas} />
            </div>
          
        </>
      )}
    </div>
  );
}

export default TablaVisitas;
